import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from 'ng2-translate';

import { ConfirmationComponent } from './confirmation.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [ConfirmationComponent],
  exports: [ConfirmationComponent]
})
export class ConfirmationModule { }


// WEBPACK FOOTER //
// ./src/app/shared/modules/confirmation/confirmation.module.ts